"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FittecFtpApi = void 0;
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var document_translations_1 = require("@src/services/document-translations");
var fromFittec_1 = require("../contract-templates/fromFittec");
var fromFittec_2 = require("../studios/fromFittec");
var FITTEC_DOCUMENTS_URL = 'https://files.fittec.io/files/fitcloud-configs/data';
var FittecFtpApi = /** @class */ (function () {
    function FittecFtpApi() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    FittecFtpApi.prototype.getStudios = function () {
        return __awaiter(this, void 0, void 0, function () {
            var studios, enabledStudios, language, translations_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getJson('studios/all-studios.json')];
                    case 1:
                        studios = _b.sent();
                        enabledStudios = studios.filter(function (studio) { return studio.enabled !== false; });
                        language = ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.useTranslations) === true ? (0, document_translations_1._GetDocumentTranslationLanguage)(this.config.get) : undefined;
                        if (!language) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getOptionalJson("translations/studios/studios-".concat(encodeURIComponent(language), ".json"))];
                    case 2:
                        translations_1 = _b.sent();
                        if (translations_1) {
                            enabledStudios.forEach(function (studio) { return (0, document_translations_1.mergeTranslatedPaths)(studio, translations_1[studio.id]); });
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/, enabledStudios.map(function (studio) { return (0, fromFittec_2.convertStudioFromFittec)(studio); })];
                }
            });
        });
    };
    FittecFtpApi.prototype.getOfferings = function (studioId) {
        return __awaiter(this, void 0, void 0, function () {
            var documentPath, contracts, enabledContracts, language;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!studioId) {
                            throw new Error('Cannot load Fittec FTP contracts without a studioId.');
                        }
                        documentPath = "contract-templates/per-studio/".concat(encodeURIComponent(studioId), ".json");
                        return [4 /*yield*/, this.getJson(documentPath)];
                    case 1:
                        contracts = _b.sent();
                        enabledContracts = contracts.filter(function (contract) { return contract.enabled !== false; });
                        language = ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.useTranslations) === true ? (0, document_translations_1._GetDocumentTranslationLanguage)(this.config.get) : undefined;
                        if (!language) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all(enabledContracts.map(function (contract) { return __awaiter(_this, void 0, void 0, function () {
                                var translations;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.getOptionalJson("translations/contracts/".concat(encodeURIComponent(contract.id), "-").concat(encodeURIComponent(language), ".json"))];
                                        case 1:
                                            translations = _a.sent();
                                            (0, document_translations_1.mergeTranslatedPaths)(contract, translations);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, enabledContracts.map(function (contract) { return (0, fromFittec_1.convertContractTemplateFromFittec)(contract); })];
                }
            });
        });
    };
    Object.defineProperty(FittecFtpApi.prototype, "documentsUrl", {
        get: function () {
            var _a, _b;
            var documentTenant = ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.fittecId) || ((_b = this.config.get) === null || _b === void 0 ? void 0 : _b.tenantKey);
            if (!documentTenant) {
                throw new Error('Cannot load Fittec FTP documents without a fittecId or tenantKey.');
            }
            // const environmentPath = this.config.get?.environment !== 'prod' ? '/dev' : '';
            var environmentPath = '';
            return "".concat(FITTEC_DOCUMENTS_URL).concat(environmentPath, "/").concat(encodeURIComponent(documentTenant));
        },
        enumerable: false,
        configurable: true
    });
    FittecFtpApi.prototype.getJson = function (documentPath) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(this.documentsUrl, "/").concat(documentPath), { method: 'GET' })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("Failed loading Fittec FTP document \"".concat(documentPath, "\" (").concat(response.status, ")."));
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, (_b.sent())];
                    case 4:
                        _a = _b.sent();
                        throw new Error("Fittec FTP document \"".concat(documentPath, "\" does not contain valid JSON."));
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FittecFtpApi.prototype.getOptionalJson = function (documentPath) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getJson(documentPath)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        console.warn("Could not load optional Fittec FTP document \"".concat(documentPath, "\"."), error_1);
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FittecFtpApi;
}());
exports.FittecFtpApi = FittecFtpApi;
